import { asyncNotiDecorator } from "./ui_util";
/* jshint esversion: 6 */
/* jshint asi: true */
let qq = require("fine-uploader");
let $tingle = require("tingle.js");

class SourceFile {
  constructor(name, content) {
    this.name = name
    this.reference = this.getReference()
    this.content = content
  }

  getReference() {
    /* Reference of liquid files (unlike other files) includes extension */
    if (this.name.endsWith('.liquid')) {
      return this.name;
    }

    return this.name.slice(0, this.name.lastIndexOf('.'))
  }
}

export default (function() {
  function Uploader() {
    this.init();
  }

  Uploader.prototype.init = function() {
    let script;
    script = document.createElement("script");
    script.type = "text/template";
    script.id = "qq-template";
    script.text = template;
    $("body").append(script);
  };

  Uploader.open = function(node) {
    let modal = new $tingle.modal({
      closeMethods: [],
      footer: true,
      stickyFooter: true
    });

    modal.open();
    modal.setContent('<div id="uploader"></div>');

    modal.addFooterBtn("Upload", "tingle-btn tingle-btn--primary tingle-btn--pull-right", function() {});

    modal.addFooterBtn("Close", "tingle-btn tingle-btn--default tingle-btn--pull-right", function() {
      modal.destroy();
    });

    let folderReference = CodeEditor.Main.generateReference(node, node.title, "asset");

    CodeEditor.Main.generateReference(node, node.title, "asset");
    new qq.FineUploader({
      button: $(".tingle-btn--primary")[0],
      element: document.getElementById("uploader"),
      request: {
        inputName: "file",
        endpoint: "/api/v1/code_editor/upload?folder=" + folderReference + "&theme_id=" + CodeEditor.Main.themeId(),
        customHeaders: {
          "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content")
        }
      },
      callbacks: {
        onError: function(_id, _name, errorReason) {
          console.log(errorReason);
        },
        onComplete: function(_id, _fileName, data) {
          if (data.success == true) {
            node.addChildren({
              key: data.key,
              title: data.title,
              extraClasses: "file file-image",
              data: {
                reference: data.reference,
                path: data.path,
                file_type: data.file_type,
                image_url: data.image_url,
                secure_random: data.key
              }
            });
            node.setExpanded();
            CodeEditor.Main.orderFoldersFirst(window.tree.getRootNode(), null, true);
          }
        }
      }
    });
  };

  /**
   * Allows uploading of multiple files programatically, and extracting their content
   *
   * @param {string} file_type can be assets, template
   * @returns {Promise} if successful, this will resolve a SourceFile object
   */
  Uploader.upload = asyncNotiDecorator(function (targetPath) {
    const MAX = 10;
    const MAX_SIZE = 500000;
    let uploadedFiles = []

    return new Promise((resolve, reject) => {
      let $input = document.createElement("input")
      $input.type = "file"
      $input.multiple = true

      $input.addEventListener("change", async function () {
        if (this.files.length > MAX) {
          return reject(`A maximum of ${MAX} files allowed at a time`)
        }

        let content = null;

        for (let f of this.files) {
          try {
            if (!Uploader.isValidFile(f.name, targetPath)) {
              reject(`${f.name} is not a valid file type for the path ${targetPath}`)
              break
            }

            if(f.size > MAX_SIZE) {
              reject(`${f.name} size is too big. Maximum allowed is ${MAX_SIZE / 1000} kb`)
              break
            }

            content = await f.text()
          } catch(e) {
            reject(e)
          }

          uploadedFiles.push(new SourceFile(f.name, content))
        }

        resolve(uploadedFiles)
      });

      $input.click()
    })
  }, "Files uploaded. Saving them now...");

  /**
   * Checks if a file belongs to an Ixcanul directory (tree)
   */
  Uploader.isValidFile = function (filename, targetPath) {
    if (!targetPath || !targetPath) {
      return false;
    }

    const PATHS_BY_TYPE = {
      "js": ["assets/javascripts/"],
      "css": ["assets/stylesheets/"],
      "scss": ["assets/stylesheets/"],
      "liquid": ["layouts/", "snippets/", "templates/"],
    };
    /* NOTE: postfix is a custom String method. Check main.js */
    const extension = filename.postfix('.').toLowerCase();
    if (!PATHS_BY_TYPE.hasOwnProperty(extension)) {
      return false;
    }

    const slashedPath = targetPath.endsWith('/') ? targetPath : `${targetPath}/`;
    return PATHS_BY_TYPE[extension].some(path => slashedPath.startsWith(path));
  }

  return Uploader;
})();

var template =
  '<div class="qq-uploader-selector qq-uploader qq-gallery" qq-drop-area-text="Drop files here or click the Upload button..."><div class="qq-upload-drop-area-selector qq-upload-drop-area" qq-hide-dropzone><span class="qq-upload-drop-area-text-selector"></span></div><span class="qq-drop-processing-selector qq-drop-processing"><span>Processing dropped files...</span><span class="qq-drop-processing-spinner-selector qq-drop-processing-spinner"></span></span><ul class="qq-upload-list-selector qq-upload-list" role="region" aria-live="polite" aria-relevant="additions removals"><li><span role="status" class="qq-upload-status-text-selector qq-upload-status-text"></span><div class="qq-progress-bar-container-selector qq-progress-bar-container"><div role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" class="qq-progress-bar-selector qq-progress-bar"></div></div><span class="qq-upload-spinner-selector qq-upload-spinner"></span><div class="qq-thumbnail-wrapper"><img class="qq-thumbnail-selector" qq-max-size="120" qq-server-scale></div><button type="button" class="qq-upload-cancel-selector qq-upload-cancel">X</button><button type="button" class="qq-upload-retry-selector qq-upload-retry"> <span class="qq-btn qq-retry-icon" aria-label="Retry"></span> Retry </button> <div class="qq-file-info"> <div class="qq-file-name"> <span class="qq-upload-file-selector qq-upload-file"></span> <span class="qq-edit-filename-icon-selector qq-btn qq-edit-filename-icon" aria-label="Edit filename"></span> </div> <input class="qq-edit-filename-selector qq-edit-filename" tabindex="0" type="text"> <span class="qq-upload-size-selector qq-upload-size"></span> <button type="button" class="qq-btn qq-upload-delete-selector qq-upload-delete"> <span class="qq-btn qq-delete-icon" aria-label="Delete"></span> </button> <button type="button" class="qq-btn qq-upload-pause-selector qq-upload-pause"> <span class="qq-btn qq-pause-icon" aria-label="Pause"></span> </button> <button type="button" class="qq-btn qq-upload-continue-selector qq-upload-continue"> <span class="qq-btn qq-continue-icon" aria-label="Continue"></span> </button> </div> </li> </ul> <dialog class="qq-alert-dialog-selector"> <div class="qq-dialog-message-selector"></div> <div class="qq-dialog-buttons"> <button type="button" class="qq-cancel-button-selector">Close</button> </div> </dialog> <dialog class="qq-confirm-dialog-selector"> <div class="qq-dialog-message-selector"></div> <div class="qq-dialog-buttons"> <button type="button" class="qq-cancel-button-selector">No</button> <button type="button" class="qq-ok-button-selector">Yes</button> </div> </dialog> <dialog class="qq-prompt-dialog-selector"> <div class="qq-dialog-message-selector"></div> <input type="text"> <div class="qq-dialog-buttons"> <button type="button" class="qq-cancel-button-selector">Cancel</button> <button type="button" class="qq-ok-button-selector">Ok</button> </div> </dialog> </div>';
